var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('div',{staticClass:"container mt-4 p-2"},[_c('ContentWP',{attrs:{"type":_vm.typePage,"slug":_vm.$route.params.slug}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }